export type TextMessageTaxIdType = "EIN" | "CBN";

export type TextMessageBusinessType =
	| "CO_OPERATIVE"
	| "CORPORATION"
	| "GOVERNMENT"
	| "LLC"
	| "NON_PROFIT"
	| "PARTNERSHIP"
	| "PRIVATE_CORPORATION"
	| "PUBLIC_CORPORATION";

export const textMessageTaxIdTypes: { id: TextMessageTaxIdType; label: string }[] = [
	{ id: "EIN", label: "EIN" },
	{ id: "CBN", label: "Canadian BN" },
];

export const textMessageBusinessTypes: { id: TextMessageBusinessType; label: string }[] = [
	{ id: "CO_OPERATIVE", label: "Co-operative" },
	{ id: "CORPORATION", label: "Corporation" },
	{ id: "GOVERNMENT", label: "Government" },
	{ id: "LLC", label: "Limited Liability Corporation" },
	{ id: "NON_PROFIT", label: "Non-profit Corporation" },
	{ id: "PARTNERSHIP", label: "Partnership" },
	{ id: "PRIVATE_CORPORATION", label: "Private Corporation" },
	{ id: "PUBLIC_CORPORATION", label: "Public Corporation" },
];
